<template>

    <DetailsSection class="step">
        <template slot="header">
            <media-only desktop>
                        <span class="step-number">
                        </span>
            </media-only>
            {{$t('Cancellation.header.deviatingCustomerData')}}
        </template>

        <p>{{$t('Cancellation.cancel.deviatingPersonText')}}</p>

        <div class="form-row">
            <div class="form-group col-sm-6">
                <input type="text" v-model.lazy="cancellation.firstname" class="form-control input-gray"
                       :required="requireInput"
                       :placeholder="$t('Generic.firstname')"
                       :aria-label="$t('Generic.firstname')" />
            </div>
            <div class="form-group col-sm-6">
                <input type="text" v-model.lazy="cancellation.lastname" class="form-control input-gray"
                       :required="requireInput"
                       :placeholder="$t('Generic.lastname')"
                       :aria-label="$t('Generic.lastname')" />
            </div>
            <div class="form-group col-sm-12">
                <input type="email" v-model.lazy="cancellation.email" class="form-control input-gray"
                       :required="requireInput"
                       :placeholder="$t('Generic.email')"
                       :aria-label="$t('Generic.email')" />
            </div>
        </div>
    </DetailsSection>
</template>

<script>
    import DetailsSection from '@/components/DetailsSection';

    export default {
        name: 'CustomerData',
        components: {
            DetailsSection
        },
        data() {
            return {
            };
        },
        props: {
            cancellation: {
                type: Object,
                required: true
            }
        },
        computed: {
            requireInput() {
                return (this.cancellation.firstname !== '' || this.cancellation.lastname !== '' || this.cancellation.email !== '');
            }
        }
    }
</script>

<style scoped>

</style>
